import { render, staticRenderFns } from "./AssumptionsNonResidentialNewYears.vue?vue&type=template&id=644580c8&scoped=true&"
import script from "./AssumptionsNonResidentialNewYears.vue?vue&type=script&lang=js&"
export * from "./AssumptionsNonResidentialNewYears.vue?vue&type=script&lang=js&"
import style0 from "./AssumptionsNonResidentialNewYears.vue?vue&type=style&index=0&id=644580c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644580c8",
  null
  
)

export default component.exports